export default Object.freeze({
  PENDING: 'Pending',
  ISSUED: 'Issued',
  NOT_ISSUED: 'NotIssued',
});
